import React, { useContext, useState } from 'react';
import Form from '../../..';
import * as S from './styled';
import DateFilter from '../../../../DateFilter';
import { setFilterColumn } from '../../../../../store/utils';
import { ExportContext } from '../../../../../provider/ExportProvider';

export default function FormCompanyFilter() {
  const {
    getAutocompleteItems,
    setAutocompleteItems,
    getFilterField,
    setField,
    setSearchFilter,
    searchFilter,
    setInvoice,
  } = useContext(ExportContext)!.controllers.company;

  const getItems = (field: keyof InvoiceState['autocompletes']['companies']) =>
    getAutocompleteItems(field);

  const [nameLoading, setNameLoading] = useState(false);
  const autocompleteNames = () => {
    setNameLoading(true);
    setAutocompleteItems('name').finally(() => {
      setNameLoading(false);
    });
  };

  return (
    <S.Form>
      <S.Body>
        <S.BodyContainer>
          <S.Field>
            <Form.Input.Dropdown
              label="Nome"
              value={getFilterField('name') as string}
              onChange={setField('name')}
              items={getItems('name')}
              errorMessage={false}
              onSelected={(item) => {
                setField('name')({
                  target: {
                    value: `${item.name}`,
                  },
                });
              }}
              onDebouncedChange={autocompleteNames}
              onFocus={() => {
                setField('name')({
                  target: {
                    value: '',
                  },
                });
              }}
              hasClearItem
              loading={nameLoading}
            />
          </S.Field>

          <S.DateContainer>
            <S.Label>Data de criação</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('createdAt', 'GEQ') as string}
                onChange={setField('createdAt', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('createdAt', 'LT') as string}
                onChange={setField('createdAt', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('createdAt', 'GEQ') as string}
              finalDate={getFilterField('createdAt', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'createdAt',
                  initialDate,
                  searchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('createdAt', finalDate, filter, 'LT');
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>
          <S.DateContainer>
            <S.Label>Data de atualização</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('updatedAt', 'GEQ') as string}
                onChange={setField('updatedAt', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('updatedAt', 'LT') as string}
                onChange={setField('updatedAt', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('updatedAt', 'GEQ') as string}
              finalDate={getFilterField('updatedAt', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'updatedAt',
                  initialDate,
                  searchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('updatedAt', finalDate, filter, 'LT');
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>
        </S.BodyContainer>
      </S.Body>
      <S.ClearButton
        onClick={(e) => {
          e.preventDefault();
          setInvoice('filters.companies.filter.filter', []);
        }}
      >
        Limpar
      </S.ClearButton>
    </S.Form>
  );
}
